<template>
  <div class="check-out">
    <booking-header-details
      @edit="$emit('edit-query', $event)"
    />
    <div
      v-if="!isBookingEditMode"
      class="notification"
      data-component="booking-notification"
    >
      <div class="container">
        <span class="text">{{ check.isMdAndDown ? tc('booking.benefitsMobile') : tc('booking.benefitsDesktop') }}</span>
        <!-- <a>{{tc('booking.details')}}</a> -->
        <room-upgrade-modal v-if="!isFanClubBooking && showRoomUpgradeButton && !haveRoomUpgradeEnhancementSelected && !isBookingEditMode">
          <template
            slot-scope="{ activate }"
          >
            <button
              class="room-upgrade-modal activator"
              :class="{'loading': roomUpgradeLoading, 'upgrade-selected': roomUpgradeSelected}"
              @click.prevent="handleUpgradeRoomClick($event, activate)"
              @keydown.space.prevent="activate"
            >
              {{ roomUpgradeSelected ? tc('booking.removeUpgrade') : tc('booking.upgradeAvailable') }}
            </button>
          </template>
        </room-upgrade-modal>
      </div>
    </div>
    <div
      class="main-wrapper"
      data-component="booking-checkout-wrapper"
    >
      <booking-check-out-fanclub
        v-if="isFanClubBooking"
        :reasons-to-stay="reasonsToStay"
        :user-titles="userTitles"
        :order-confirmation-page="orderConfirmationPage"
        :modify-detail-page="modifyDetailPage"
        @show-cart="$emit('show-cart')"
      />
      <booking-check-out
        v-else
        :reasons-to-stay="reasonsToStay"
        :user-titles="userTitles"
        :order-confirmation-page="orderConfirmationPage"
        :modify-detail-page="modifyDetailPage"
        @show-cart="$emit('show-cart')"
      />
      <cart-overview v-if="check.isLgAndUp" />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import Tracking from '@mixins/tracking'
  import BookingHeaderDetails from '../../components/booking-header-details/booking-header-details.vue'
  import CartOverview from './components/cart-overview.vue'
  import BookingCheckOut from './components/booking-check-out.vue'
  import BookingCheckOutFanclub from './components/booking-check-out-fanclub.vue'
  import RoomUpgradeModal from '../../components/room-upgrade-modal/room-upgrade-modal.vue'

  export default {
    name: 'CheckOut',
    components: {
      BookingHeaderDetails,
      CartOverview,
      BookingCheckOut,
      BookingCheckOutFanclub,
      RoomUpgradeModal
    },
    mixins: [Tracking],
    props: {
      reasonsToStay: {
        type: Array,
      },
      userTitles: {
        type: Array,
      },
      orderConfirmationPage: {
        type: String
      },
      modifyDetailPage: {
        type: String
      },
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('global', ['isFanClubBooking']),
      ...mapState('booking', { bookingReady: 'ready' }),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      ...mapState('responsive', ['check']),
      ...mapGetters('booking', ['getBookingTrackingV2', 'getQuery', 'bookingFlow']),
      ...mapState('cart', ['cart', 'showRoomUpgradeButton', 'roomUpgradeLoading', 'roomUpgradeSelected']),
      ...mapGetters('cart', ['itemsInCart', 'getRoomUpgradesOptions', 'enhancementsInRoom']),

      isMultiRoom() {
        return Number(this.getQuery.roomQuantity) > 1
      },
      haveRoomUpgradesOptions() {
        return this.getRoomUpgradesOptions && this.getRoomUpgradesOptions.length > 0
      },
      haveSpecialCode() {
        return !!this.getQuery.iataNumber
      },
      haveRoomUpgradeEnhancementSelected() {
        return this.enhancementsInRoom.some((enhancement) => enhancement.synXisId === 'FANUPR')
      },
      shouldVerifyRoomUpgradeAvailability() {
        return this.haveRoomUpgradesOptions && !this.isMultiRoom && !this.haveSpecialCode && !this.haveRoomUpgradeEnhancementSelected && !this.roomUpgradeSelected
      },
    },
    watch: {
      shouldVerifyRoomUpgradeAvailability(val) {
        if (val) {
          this.getRoomUpgradesAvailability()
        }
      }
    },
    mounted() {
      if (this.bookingReady) {
        if (this.shouldVerifyRoomUpgradeAvailability) {
          this.getRoomUpgradesAvailability()
        }
      }

      this.$nextTick(() => {
        this.$track(this.getTrackingData('booking', this.getQuery, { event: 'step6' }))
        this.$track(this.getTrackingData(this.isBookingEditMode ? 'modifyReservation' : 'booking', undefined, {
          event: 'bookingStateChange',
          bookingEngine: {
            bookingStepNumber: this.isBookingEditMode ? '3' : '4',
            bookingStepName: this.isBookingEditMode ? 'Guest Details' : 'Checkout',
            bookingEngineVersion: this.isBookingEditMode ? '2' : '1',
            bookingFlow: this.bookingFlow()
          }
        }))
      })
    },
    methods: {
      ...mapActions('cart', ['getRoomUpgradesAvailability', 'removeRoomUpgrade']),
      async submit() {
        await this.nextStep()
      },
      handleUpgradeRoomClick(event, activate) {
        if (this.roomUpgradeSelected) {
          this.removeRoomUpgrade().then(() => {
            this.$track(this.getBookingTrackingV2(this.getQuery, { event: 'upgradeRemoved', upgradeName: `${this.cart.lines[0].sitecoreContent.room.title} - ${this.cart.lines[0].sitecoreContent.bed.title}` }))
          })
        } else {
          activate(event)
        }
      }
    }
  }

</script>
